import { OrderDirection, SortOrder } from 'common/utils/commonTypes';
import { TABLE_ROWS } from 'common/constants';
import { WorkgroupGroupsOrderBy } from 'common/types/globalTypes';
import { WorkgroupGroupsVariables } from 'settings/account/workgroupGroups/list/__generated__/WorkgroupGroups';

type OrderLookup = {
  [direction in OrderDirection]: WorkgroupGroupsOrderBy[];
};

const orderByMap = new Map<string, OrderLookup>([
  [
    'name',
    {
      [OrderDirection.ASC]: ['NAME_ASC'],
      [OrderDirection.DESC]: ['NAME_DESC'],
    },
  ],
]);

export const toOrderByVariable = (sort?: SortOrder) => {
  const defaultOrderBy: WorkgroupGroupsOrderBy[] = [
    'NAME_ASC',
    'PRIMARY_KEY_ASC',
  ];
  const orderByArray: WorkgroupGroupsOrderBy[] = ['PRIMARY_KEY_ASC'];
  if (!sort) return defaultOrderBy;
  const orderBy = orderByMap.get(sort.column)?.[sort.direction];
  return Array.from(new Set([...(orderBy ? orderBy : []), ...orderByArray]));
};

export const onHandleSearch = (sortOrderParam: SortOrder | undefined) => {
  const variables: WorkgroupGroupsVariables = {
    first: TABLE_ROWS,
    orderBy: toOrderByVariable(sortOrderParam),
  };
  return {
    queryVariables: variables,
  };
};
